import { Observable } from 'rxjs/Observable';
import { AbstractControl } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { map, take, debounceTime } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { auth } from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class FireValidatorsService {
  company;
  constructor(
  ) {
  }
  static checkExistTwoObjectKey(afs: AngularFirestore, collection: string, field1: string, field2?: string, key?: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        let val = value.key;
        if (val === undefined) {
          val = null;
        }
        return afs
          .collection(collection, ref => ref.where(field1, '==', val).where(field2, '==', key).limit(1))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map((arr) => {
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }
    };
  }

  static checkExistObjectKey(afs: AngularFirestore, collection: string, field: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        let val = value.key;
        if (val === undefined) {
          val = null;
        }
        return afs
          .collection(collection, ref => ref.where(field, '==', val).limit(1))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map((arr) => {
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }
    };
  }

  static checkExistPrerequisite(afs: AngularFirestore, curriculumSubject: any, collection: string, field: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        const key = value.subject ? value.subject.key : null;
        return afs
          .collection(collection, ref => ref.where(field, '==', key)
            .where('subject.curriculum.key', '==', curriculumSubject.curriculum.key))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map(arr => {
              if (!key) {
                return { validKey: true };
              }
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }
    };
  }
  static checkExistKeyValue(afs: AngularFirestore, collection: string, field: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        const key = value.key ? value.key : null;
        return afs
          .collection(collection, ref => ref.where(field, '==', key))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map(arr => {
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }
    };
  }


  static checkExistByCompany(afs: AngularFirestore, companyKey, collection: string, field: string, editData?: any) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        return afs
          .collection(collection, ref => ref.where(field, '==', value.trim())
            .where('organizationKey', '==', companyKey)
            .where('isDelete', '==', false))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map(arr => {
              if (editData && arr.length > 0 && arr[0][field] === editData) {
                return null;
              }
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }


    };
  }

  static checkExist(afs: AngularFirestore, collection: string, field: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        return afs
          .collection(collection, ref => ref.where(field, '==', value.trim())
            // .where('isDelete', '==', false)
          )
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map(arr => {
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }
    };
  }

  static checkExistOnEdit(afs: AngularFirestore, collection: string, field: string, oldValue: string) {

    return (control: AbstractControl) => {
      const value = control.value;
      if (value === oldValue) {
        const val = null;
        return val
      }
      if (value !== null && value !== '' && value !== undefined && value !== oldValue) {
        afs
          .collection(collection, ref => ref.where(field, '==', value.trim()))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map(arr => {
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }

    };
  }
  static checkValid(afs: AngularFirestore, collection: string, field: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        return afs
          .collection(collection, ref => ref.where(field, '==', value))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map(arr => {
              const val = arr.length === 1 ? null : { nameAvailable: true };
              return val;
            })
          );
      }
    };
  }
  static checkValidSelect(afs: AngularFirestore, collection: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined) {
        return afs
          .collection(collection, ref => ref.where('key', '==', value.key))
          .valueChanges()
          .pipe(
            debounceTime(300),
            take(1),
            map(arr => {
              const val = arr.length === 1 ? null : { nameAvailable: true };
              return val;
            })
          );
      }
    };
  }
}

export function checkExistDoc(afs: AngularFirestore, collection: string, field: string) {
  return (control: AbstractControl) => {
    const value = control.value;
    if (value !== null && value !== "" && value !== undefined) {
      return afs
        .collection(collection, ref => ref.where(field, "==", value))
        .valueChanges()
        .pipe(
          debounceTime(300),
          take(1),
          map(arr => {
            const val = arr.length == 1 ? { nameAvailable: true } : null;
            return val;
          })
        );
    }
  };
}

export function checkExistOnEditStore(afs: AngularFirestore, storeKey: string, collection: string, field: string, oldValue: string) {
  return (control: AbstractControl) => {
    const value = control.value;
    if (value !== null && value !== "" && value !== undefined) {
      return afs
        .collection('organizations').doc(storeKey).collection(collection, ref => ref
          .where(field, "==", value))
        .valueChanges()
        .pipe(
          debounceTime(300),
          take(1),
          map(arr => {
            if (oldValue === value) {
              return null;
            }
            const val = arr.length > 0 ? { nameAvailable: true } : null;
            return val;
          })
        );
    }
  };
}
